import { LicensingAgencyStatus } from '@/@types/generated'

export const InProgressLicensingAgencyStatuses = [
  LicensingAgencyStatus.DRAFT,
  LicensingAgencyStatus.UNDER_REVIEW,
  LicensingAgencyStatus.REJECTED,
] as const satisfies LicensingAgencyStatus[]

export const CompletedLicensingAgencyStatuses = [
  LicensingAgencyStatus.ACTIVE,
  LicensingAgencyStatus.SUSPENDED,
  LicensingAgencyStatus.REVOKED,
] as const satisfies LicensingAgencyStatus[]

export const ActiveLicensingAgencyStatuses = [
  LicensingAgencyStatus.ACTIVE,
] as const satisfies LicensingAgencyStatus[]

export const UnauthorizedLicensingAgencyStatuses = [
  LicensingAgencyStatus.REJECTED,
  LicensingAgencyStatus.SUSPENDED,
  LicensingAgencyStatus.REVOKED,
] as const satisfies LicensingAgencyStatus[]

export function isLicensingAgencyStatus(
  statuses: readonly LicensingAgencyStatus[],
  status?: LicensingAgencyStatus
): boolean {
  if (!status) return false
  return (statuses as LicensingAgencyStatus[]).includes(status)
}

// Compile-time exhaustiveness check
const AllLicensingAgencyStatuses = [
  ...InProgressLicensingAgencyStatuses,
  ...CompletedLicensingAgencyStatuses,
] as const
type MissingLicensingAgencyStatuses = Exclude<
  LicensingAgencyStatus,
  (typeof AllLicensingAgencyStatuses)[number]
>
// If this line causes a TypeScript error, it means that not all LicensingAgencyStatus values are included
// in either InProgressLicensingAgencyStatuses or CompletedLicensingAgencyStatuses. Please update the arrays accordingly.
const _allLicensingAgencyStatusesIncluded: MissingLicensingAgencyStatuses extends never
  ? true
  : never = true
void _allLicensingAgencyStatusesIncluded
// End compile-time exhaustiveness check
